/** Generate an SVG data URI for a solid rounded rectangle used as filter background. */
export const getFilterSolid = (color = 'white') =>
  `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'
    x='0px' y='0px' viewBox='0 0 400 40' height='40' width='400'%3E%3Crect fill='${color}'
    x='0' y='0' rx='40' ry='40' width='400' height='40'/%3E%3C/svg%3E`;

/** Build a path config object for the power-flow animation, with sensible defaults. */
export const getPathConfig = (params: object, duration: number, defaults?: object) => ({
  blur: false,
  color: 'black',
  delay: 0,
  duration,
  size: 3,
  ...defaults,
  ...params,
});
